import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('apiToolsStore')
@observer
class ApiManagement extends Component {
  state = {
  }
  componentDidMount() {
  }
  render() {
    const { apiToolsStore } = this.props
    const { isFetching } = apiToolsStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default ApiManagement;
